import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import Hero from './components/Hero';
import FeatureGrid from './components/FeatureGrid';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import FeaturedGuides from './components/FeaturedGuides';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuyspread.pics';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'Superbuy Sheet',
      url: siteUrl,
      description: 'Discover updated product collections, category guides and shopping resources for smarter international shopping with Superbuy Sheet.',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      url: siteUrl,
      name: 'Superbuy Sheet - Find Products Faster With Organized Shopping Resources',
      description: 'Superbuy Sheet helps you discover updated product collections, category guides and shopping resources for smarter international shopping. Explore shoes, hoodies, jackets, bags, accessories and more.',
      isPartOf: {
        '@type': 'WebSite',
        name: 'Superbuy Sheet',
        url: siteUrl,
      },
      about: {
        '@type': 'Organization',
        name: 'Superbuy Sheet Research Team',
        url: siteUrl,
        description: 'All guides are researched, reviewed and updated regularly to provide accurate and useful Superbuy Sheet information.',
      },
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead jsonLd={homeJsonLd} />
      <Navbar />
      <main>
        <Hero />
        <FeatureGrid />
        <CategoryGrid />
        <CTASection />
        <FeaturedGuides />
        <AboutSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}